@if (!onlyShowText) {
  <div
    class="ui-dropdown-container"
    [class.opened]="isOpen"
    (clickOutside)="isOpen && toggleDropdown()"
  >
    @if (selectedOption) {
      <div class="ui-dropdown-opener item" (click)="toggleDropdown()">
        <div class="item-title title">
          <span [attr.e2e-attr]="e2eAttrs.UI_DROPDOWN_SELECTED_ITEM_TITLE">{{
            selectedOption.title
          }}</span>
          <i class="icon-ok-2"></i>
        </div>
        @if (selectedOption.subtitle) {
          <div
            [attr.e2e-attr]="e2eAttrs.UI_DROPDOWN_SELECTED_ITEM_SUBTITLE"
            class="item-subtitle"
          >
            {{ selectedOption.subtitle }}
          </div>
        }
      </div>
    }
    @if (!selectedOption) {
      <div
        class="ui-dropdown-opener item no-selected-value"
        (click)="toggleDropdown()"
      >
        <div class="item-title" [class.placeholder]="placeholder">
          {{
           (placeholder || I18n.CommonPlaceholders.NothingSelectedYet)
              | translate
          }}
        </div>
      </div>
    }
    <div class="arrow-icon" (click)="toggleDropdown()">
      <i class="icon-angle-down"></i>
    </div>
    @if (isDropdownOpen) {
      <div class="item-list">
        @for (option of optionsList; track option) {
          <div (click)="onSelectOption(option)" class="item">
            <div class="item-title">
              <span [attr.e2e-attr]="e2eAttrs.UI_DROPDOWN_ITEM_TITLE">{{
                option.title
              }}</span>
              @if (option === selectedOption) {
                <i class="icon-ok-2"></i>
              }
            </div>
            @if (option.subtitle) {
              <div
                [attr.e2e-attr]="e2eAttrs.UI_DROPDOWN_ITEM_SUBTITLE"
                class="item-subtitle"
              >
                {{ option.subtitle }}
              </div>
            }
          </div>
        }
      </div>
    }
    @if (isOpen) {
      <div class="black-container"></div>
    }
  </div>
} @else {
  <div class="disabled">{{ selectedOption?.title }}</div>
}
